import {Controller, useFormContext} from "react-hook-form";
import {useContext} from "react";
import {ProductFormContext} from "@/lib/product-form-context";

export const DeclineAction = ({
  type,
  label,
  decisionIndex
}:{
  type: 'radio' | 'checkbox';
  label?: string;
  decisionIndex?: number;
}) => {

  const form = useFormContext();
  const productFormContext = useContext(ProductFormContext);
  const radioGroupName = decisionIndex !== undefined ? 
    `radio-group-${productFormContext}-${decisionIndex}` : 
    `radio-group-${productFormContext}`;

  return (
    <Controller
      name={`products[${productFormContext}]`}
      control={form.control}
      render={({field}) => (
        <label className="flex w-full gap-2 items-center p-2 border rounded cursor-pointer bg-neutral/20">
          <input 
            {...field} 
            type={type} 
            name={type === 'radio' ? radioGroupName : undefined}
            checked={decisionIndex !== undefined ? 
              field.value?.offer_declined?.[decisionIndex] : 
              field.value?.offer_declined} 
            onChange={() => {
              let currentValues = field.value?.accepted_quotes || [];
              let declinedState = field.value?.offer_declined || {};

              if (decisionIndex !== undefined) {
                // Only clear quotes from the current decision group
                currentValues = currentValues.filter((q: string) => !document.querySelector(`input[name="${radioGroupName}"][value="${q}"]`));
                // Set declined state for this specific decision group
                declinedState = {
                  ...declinedState,
                  [decisionIndex]: true
                };
              } else {
                // If no decisionIndex, clear all (legacy behavior)
                currentValues = [];
                declinedState = true;
              }

              field.onChange({
                offer_declined: declinedState,
                accepted_quotes: currentValues,
                available_quotes: field.value?.available_quotes ?? []
              });
              form.trigger(`products[${productFormContext}]`);
            }}
          />
          <div className="text-xs">{label || 'Decline Coverage'}</div>
        </label>
      )}
    />
  );
}
